import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { IFormItem } from '~domain/entities/Config';
import { classes } from '~utils/Classes';

const StyledTermsConditions = styled.div`
    margin-top: 20px;
`;

const termsAgreementClassName = classes('iam-terms-conditions');

export const TermsConditions = observer((props: IFormItem) => {
    const { inputLabel = '' } = props;

    return (
        <StyledTermsConditions
            className={termsAgreementClassName}
            dangerouslySetInnerHTML={{
                __html: inputLabel
            }}
        />
    );
});
